import { useEffect, useLayoutEffect, useState, useRef } from 'react';

export function useTime(interval = 100) {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const ref = setInterval(() => setTime(new Date()), interval);
    return () => clearInterval(ref);
  });

  return time;
}

export function useElementRect() {
  function getElementRect(el) {
    if (el.current === null) {
      return { width: 0, height: 0 };
    }

    return { width: el.current.clientWidth, height: el.current.clientHeight };
  }

  const el = useRef(null);
  const [value, setValue] = useState(getElementRect(el));

  const setElementRect = () => {
    setValue(getElementRect(el));
  };

  useLayoutEffect(() => {
    setElementRect();
  }, [el.current]);

  useEffect(() => {
    window.addEventListener('resize', setElementRect);

    return () => {
      window.removeEventListener('resize', setElementRect);
    };
  }, []);

  return [el, value];
}

export function useElementRatios(parentRect) {
  const [ref, elRect] = useElementRect();
  if (!parentRect || !ref) {
    return [ref, { width: 0, height: 0 }];
  }

  const findRound = (value, multiplier = 6) => {
    return Math.round(value * multiplier) / multiplier;
  };

  const findLabel = percentage => {
    if (isNaN(percentage)) {
      return null;
    }
    if (percentage === 1.0) {
      return 'full';
    }

    if (percentage === 0.5) {
      return 'half';
    }

    if (percentage === 1 / 3) {
      return 'third';
    }

    return null;
  };

  const slideWidth = parentRect.width;
  const slideHeight = parentRect.height;

  const percentageW = elRect.width / slideWidth;
  const percentageH = elRect.height / slideHeight;

  const width = findLabel(findRound(percentageW, 6)) || 0;
  const height = findLabel(findRound(percentageH, 6)) || 0;
  return [ref, { width, height }];
}
